// Shared money rounding. Whole cents: round the size first, then apply the sign, so -12.345 and
// 12.345 round alike (Math.round alone rounds a negative half toward zero). Never returns -0.
export function toWholeCents(n) {
  const c = Math.sign(n) * Math.round(Math.abs(n) * 100);
  return c === 0 ? 0 : c;
}

// On-screen money: "$1,234", "-$1,234", "$1,234.50". Keeps the minus sign on losses. Whole dollars when
// there are no cents, otherwise exactly 2 decimals (never "$0.3"). Rounds half cents the same way for
// both signs (toWholeCents). A value that is not a number shows "$0". For wording that already says
// "lost", "over" or "down", pass Math.abs(x) so the sentence does not say "lost -$500".
export function formatMoney(v) {
  const n = Number(v);
  if (v === null || v === undefined || !Number.isFinite(n)) return "$0";
  const cents = toWholeCents(n);
  const digits = cents % 100 !== 0 ? 2 : 0;
  const body = (Math.abs(cents) / 100).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return `${cents < 0 ? "-" : ""}$${body}`;
}
